var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (this.playbacks.length > 0) ? _c('div', {
    staticClass: "is-medium"
  }, [_c('table', {
    staticClass: "table is-fullwidth has-open-spacing"
  }, [_c('tbody', _vm._l((_vm.playbacks), function(playback) {
    return _c('tr', [_c('td', [_c('playback-details', {
      attrs: {
        "playback": playback
      }
    })], 1)])
  }))])]) : _c('div', [_vm._v("\n      No items to display\n    ")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title has-text-primary"
  }, [_c('strong', [_vm._v("\n        Playback\n      ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-690ff15a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Playback.vue
// module id = 1OmB
// module chunks = 0